import { render } from "./RichtextComponent.vue?vue&type=template&id=4f52d492"
import script from "./RichtextComponent.vue?vue&type=script&lang=js"
export * from "./RichtextComponent.vue?vue&type=script&lang=js"

import "./RichtextComponent.vue?vue&type=style&index=0&id=4f52d492&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__